import React from "react";

import { STRINGS } from "../utils/string";

export default function ActionItemManual({ item }) {
  return (
    <>
      <span className="font-bold">{item?.actingUserName || STRINGS.NO_ACTING_USER_NAME}</span>
      <div className="mb-1 truncate text-ellipsis">
        {item?.shortDescription ? item?.shortDescription : STRINGS.NO_DESCRIPTION}
      </div>
    </>
  );
}
